import { render, staticRenderFns } from "./ConferenceAspot.vue?vue&type=template&id=0dcfe0de"
import script from "./ConferenceAspot.vue?vue&type=script&lang=js"
export * from "./ConferenceAspot.vue?vue&type=script&lang=js"
import style0 from "./ConferenceAspot.vue?vue&type=style&index=0&id=0dcfe0de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokComponent: require('/opt/build/repo/components/Storyblok/Component.vue').default,ElementsModal: require('/opt/build/repo/components/Elements/Modal.vue').default})
